<template>
  <div class="banner">
    <img class="logo text-ellipsis" :src="require('@/assets/img/logo.png')" />
    <swiper
        :options="swiperOption"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
    >
      <swiper-slide v-for="item in list" :key="item.id">
        <img
            class="img"
            :src="`${baseUrl}/${item.imgUrl}`"
            alt=""
            @click="openView(item.linkUrl)"
        />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import {openView} from '@/utils';

export default {
  props: {
    list: Array,
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_URL,
      swiperOption: {
        slidesPerView: 1,
        // 设置分页器
        pagination: {
          el: '.swiper-pagination',
          // 设置点击可切换
          clickable: true,
        },
        // 设置自动轮播
        autoplay: {
          delay: 15000, // 15秒切换一次
        },
        // 匀速播放频率
        speed: 1000,
      },
    };
  },
  methods: {
    openView,
    onSwiper(swiper) {
      console.log(swiper);
    },
    onSlideChange() {
      // console.log('slide change');
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;

  .logo {
    position: absolute;
    left: 50px;
    top: 20px;
    width: 240px;
    z-index: 999;
  }
}

.img {
  width: 100%;
  height: auto;
  cursor: pointer;
}
</style>
